import type React from "react";
import {useCallback} from "react";

import {faRefresh} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import CustomButton from "~/component/common/CustomButton";
import {useUserInput} from "~/contexts/user-input/UserInputCoordinatorProvider";

export const RestartButton: React.FC = () => {
  const {resetSimulation} = useUserInput();

  const handleClick = useCallback(() => {
    resetSimulation();
  }, [resetSimulation]);

  return (
    <CustomButton
      onClick={handleClick}
      aria-label="Restart level"
      className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
    >
      <FontAwesomeIcon
        icon={faRefresh}
        size="xl"
        className="text-white p-2 -m-2 rounded-full bg-gradient-to-br from-orange-600 via-orange-500 to-black"
      />
    </CustomButton>
  );
};
